import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IClickInfo) {
    (function(Type) {
        Type["BRAND"] = "BRAND";
        Type["PRODUCT"] = "PRODUCT";
        Type["FLASH_SALE"] = "FLASH_SALE";
        Type["CATEGORY"] = "CATEGORY";
        Type["LAYOUT_ELEMENT"] = "LAYOUT_ELEMENT";
        Type["SEARCH_QUERY"] = "SEARCH_QUERY";
    })(IClickInfo.Type || (IClickInfo.Type = {}));
    (function(IProductMetadata) {
        IProductMetadata.build = function(partial) {
            return _object_spread({
                promoted_by: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IClickInfo.IProductMetadata || (IClickInfo.IProductMetadata = {}));
    IClickInfo.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IClickInfo || (IClickInfo = {}));
export var IClickInfo;
